import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router';

class IncidentPreview extends React.Component {
  constructor(props) {
    super(props);

  }
  render() {
    const { incident } = this.props;
    let style = incident.damage_level == 'Light' ? 'success' : incident.damage_level == 'Moderate' ? 'warning' : 'danger';
    return (
      <section className="panel animated fadeInRight">
        <div className="panel-body bg-primary">
          <div className="widget-summary">
            <div className="widget-summary-col widget-summary-col-icon">
              <div className="summary-icon">
                <i className={`fa fa-exclamation-triangle text-${style}`}></i>
              </div>
            </div>
            <div className="widget-summary-col">
              <div className="summary">
                <h4 className="title">{incident.damage_level}</h4>
                <div className="info">
                  <span>{moment(incident.created_timestamp).fromNow()} ({moment(incident.created_timestamp).format('YYYY-MM-DD')})</span>
                </div>
              </div>
              <div className="summary-footer">
              <ul className="list-inline">
                <li>
                  <i className="fa fa-search"></i> <Link to={`client/${incident.client}/incidents/${incident._id}`} className="text-uppercase"> View Report</Link>
                </li>
                <li>
                  <i className="fa fa-download"></i> <a className="text-uppercase"> Adjuster Report</a>
                </li>
              </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

IncidentPreview.propType = {
  incident : PropTypes.object
}

class WidgetClientDamageIncidents extends React.Component {
  componentDidMount() {

  }
  render() {
    const { client, incidents } = this.props;

    return (
      <div className="damage-reports">
      <h4 className="mb-md">Damage Incidents</h4>
        <section className="panel animated fadeInRight">
          <div className="panel-body new-damage-incident">
            <div className="widget-summary">
              <div className="widget-summary-col widget-summary-col-icon hvr-grow-rotate">
                <div onClick={this.props.onCreate} className="summary-icon bg-primary">
                  <i className="fa fa-plus"></i>
                </div>
              </div>
              <div className="widget-summary-col">
                <div className="summary">
                  <h4 className="title">New Incident</h4>
                  <div className="info">
                    <strong className="amount text-uppercase text-muted">Click to add</strong>
                  </div>
                </div>
                <div className="summary-footer">
                  <i className="fa fa-question-circle fs"></i> <span className="text-muted"> Used to track damage incidents for the client</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <h4 className="mb-md">Recent Incidents</h4>
        <div className='panel'>
	        {incidents && incidents.length > 0 ? incidents.map(incident => <IncidentPreview incident={incident} />): <p className="text-center text-muted">No incidents.</p>}
        </div>
      </div>
    );
  }
}

WidgetClientDamageIncidents.propTypes = {
  client : PropTypes.object,
  incidents : PropTypes.array,
  onCreate : PropTypes.func
}

WidgetClientDamageIncidents.contextTypes = {
  router : PropTypes.object
}

export default WidgetClientDamageIncidents



// WEBPACK FOOTER //
// ./src/browser/components/client/widget-damage-incidents.js